var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCochera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21V8L12 4L21 8V21",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4297 19L17.569 19.0008V20.2864C17.569 20.523 17.3771 20.715 17.1405 20.715H16.2834C16.0469 20.715 15.4297 20.5222 15.4297 20.2857V19Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42578 19H8.5685V20.2856C8.5685 20.5222 8.18451 20.7141 7.71139 20.7141H6.85432C6.61777 20.7141 6.42578 20.5222 6.42578 20.2856V19Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13993 14.7139H15.8536C16.8002 14.7139 17.5677 15.4814 17.5677 16.428V18.5707C17.5677 18.8072 17.3757 18.9992 17.1392 18.9992H6.85432C6.61777 18.9992 6.42578 18.8072 6.42578 18.5707V16.428C6.42578 15.4814 7.19329 14.7139 8.13993 14.7139Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 16.8574C16.1796 17.0349 16.0359 17.1786 15.8584 17.1787C15.7029 17.1787 15.5728 17.0685 15.543 16.9219L15.5371 16.8574C15.5371 16.6798 15.6807 16.5361 15.8584 16.5361L15.9229 16.542C16.0695 16.5719 16.1797 16.7019 16.1797 16.8574Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 16.8574C8.46084 17.0349 8.31717 17.1786 8.13965 17.1787C7.98411 17.1787 7.85408 17.0685 7.82422 16.9219L7.81836 16.8574C7.81836 16.6798 7.96199 16.5361 8.13965 16.5361L8.2041 16.542C8.35077 16.5719 8.46094 16.7019 8.46094 16.8574Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86774 11.2861H15.1304C15.3091 11.2861 15.4689 11.3971 15.5315 11.5643L16.713 14.7144H7.28516L8.46663 11.5643C8.5292 11.3971 8.68904 11.2861 8.86774 11.2861Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.8564C6.74995 13.9514 6.70806 14.0359 6.64258 14.0947C6.59245 14.0496 6.55599 13.9895 6.54199 13.9209L6.53516 13.8564C6.53516 13.7614 6.57702 13.676 6.64258 13.6172C6.70828 13.676 6.75 13.7613 6.75 13.8564Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4648 13.8564C17.4648 13.9514 17.4229 14.0359 17.3574 14.0947C17.3073 14.0496 17.2708 13.9895 17.2568 13.9209L17.25 13.8564C17.25 13.7614 17.2919 13.676 17.3574 13.6172C17.4231 13.676 17.4648 13.7613 17.4648 13.8564Z",
    fill: "#2B363D",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 16.8564H13.7134",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCochera);
export default __webpack_public_path__ + "static/media/Cochera.5aa494957d85e19bb2435e89d9762da6.svg";
export { ForwardRef as ReactComponent };